import { render, staticRenderFns } from "./modal-save.vue?vue&type=template&id=d10a8b72&"
import script from "./modal-save.vue?vue&type=script&lang=js&"
export * from "./modal-save.vue?vue&type=script&lang=js&"
import style0 from "./modal-save.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports